import { FC, useEffect, useState } from 'react';
import { SuggestionFormInputProps } from '../interfaces/FormInput';
import { getErrorText } from '../utils/getErrorText';
import { Text } from '../../units/Text';
import "../assets/style.css"
import { FlexWrapper } from '../../Wrappers/Wrappers';

interface Suggestion {
    id: number;
    name: string;
}


export const LgSuggestionFormInput: FC<SuggestionFormInputProps> = (
    { 
        value, 
        label, 
        name, 
        inputError=null, 
        required, 
        valueSetter, 
        type='text', 
        helper='', 
        className='', 
        disabled=false,
        fetchSuggestion
    }

) => {
    const inputClassName = inputError === null 
        ? `cs-input cs-input-lg standart-border ${className}`
        : `cs-input cs-input-lg standart-border ${className} cs-input-error`
    
    const [isFocused, setIsFocused] = useState(false);
    const [suggestions, setSuggestions] = useState<Suggestion[]>([])


    useEffect(() => {
        const query = String(value ?? '').trim();

        const timeout = setTimeout(async () => {
            try {
                const data = await fetchSuggestion(query);
                setSuggestions(data);
            } catch (error) {
                console.error(error);
                setSuggestions([]);
            }
        }, 300); // debounce

        return () => clearTimeout(timeout);
    }, [value, fetchSuggestion, isFocused]);
    
    const handleSuggestionClick = (suggestion: string) => {
        valueSetter({
            target: {
                name,
                value: suggestion,
            },
        } as React.ChangeEvent<HTMLInputElement>);
    };

    return (
        <div className='flex flex-column narrow-gap relative' style={{width: '100%'}}>
            <Text size='base'>{label}{ required ? ( <span className='required-star'>*</span> ) : ('') } </Text>
            <input 
                disabled={disabled} 
                value={value === null || value === undefined ? '' : value} 
                type={type} 
                required={required} 
                placeholder={helper} 
                name={name} 
                id={name} 
                className={inputClassName} 
                onChange={valueSetter}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
            { (isFocused) && (
                <FlexWrapper 
                    className="p2 r15 suggestions-dropdown" 
                    justifyContent="flex-start"
                    gap='0.25rem'
                >
                    {suggestions.map((suggestion) => (
                        <Text
                            key={suggestion.name}
                            className={
                                `suggestion-item r10 fit-content p1 ${value === suggestion.name && 'suggestion-selected'}`
                            }
                            onMouseDown={
                                () => handleSuggestionClick(suggestion.name)
                            }
                        >
                            {suggestion.name}
                        </Text>
                    ))}
                    { suggestions.length === 0 && (
                        <>
                            <Text className='r10 fit-content p1'>При сохранении формы будет задано значение:</Text>
                            <Text className='pointer r10 fit-content p1 suggestion-selected'>{value}</Text>
                        </>
                    )}
                </FlexWrapper> 
            )}
            { inputError && <Text color='danger'>⚠️ {getErrorText(inputError)}</Text>}
        </div>
    )
}